import type {Offer} from './types'
import {numberFormatToCurrency} from '@logistics-frontend/core/formatters'

type FormatPriceOptions = {
  currencySign?: string
  country?: string
}

export function formatOfferPrice(offer: Offer, options: FormatPriceOptions) {
  const {currencySign, country} = options

  return numberFormatToCurrency(offer.price, offer.currency, country, {currencySign})
}

export * from './types'
